import { Controller } from "@hotwired/stimulus"
import { useTransition } from "stimulus-use"

// Connects to data-controller="dropdown"
export default class extends Controller {
  static targets = ["menu", "button"]

  connect() {
    useTransition(this, {
      element: this.menuTarget,
      enterActive: "transition ease-out duration-100",
      enterFrom: "transform opacity-0 scale-95",
      enterTo: "transform opacity-100 scale-100",
      leaveActive: "transition ease-in duration-75",
      leaveFrom: "transform opacity-100 scale-100",
      leaveTo: "transform opacity-0 scale-95",
    })
  }

  toggle() {
    this.toggleTransition()
    this.updateAriaExpanded()
  }

  hide(event) {
    // Handle both click outside and escape key
    const isEscapeKey = event.type === "keydown" && event.key === "Escape"
    const isClickOutside = event.type === "click" && !this.element.contains(event.target)

    if ((isClickOutside || isEscapeKey) && !this.menuTarget.classList.contains("hidden")) {
      this.leave()
      this.updateAriaExpanded()

      // Return focus to button on escape
      if (isEscapeKey && this.hasButtonTarget) {
        this.buttonTarget.focus()
      }
    }
  }

  updateAriaExpanded() {
    if (this.hasButtonTarget) {
      const isExpanded = !this.menuTarget.classList.contains("hidden")
      this.buttonTarget.setAttribute("aria-expanded", isExpanded.toString())
    }
  }
}
